<template>
    <div class="all1">
        <div class="container">
            <div class="imgText product-top clearfix">
                <div class="img fl">
                    <i class="icons" :class="'product-icon'+sid"></i>
                </div>
                <div class="hidden">
                    <h1>{{tit}}</h1>
                    <p class="ziduan mt20">
                        <span class="color-8a8a99">版本：V3.0.0</span>
                        <span class="color-8a8a99">更新时间：{{updateTime}}</span>
                    </p>
                    <p class="mt5 color-8a8a99">{{intr}}</p>
                    <button class="btn mt20 btn-jbblue" @click="openUrl">前往使用</button>
                </div>
            </div>
        </div>
        <div class="wulai mt20">
            <div class="container">
                <div class="grid-header clearfix"><h2 class="title">产品介绍</h2></div>
                <div class="mt20" v-html="proIntr">
                    {{proIntr}}
                </div>
            </div>
        </div>
	</div>
</template>
<script>
export default {
    data() {
        return {
            sid:this.$route.query.id,
            tit:'',
            updateTime:'',
            intr:'',
            proIntr:'',
            proList:[
				{id:11,name:'对比分析',urlList:'http://model.nybkz.com/schemeCompare/addDisplay',updateTime:'2018-11-27 16:58:11',intr:'用户可设置2-3个分析对象，设置对比时间段，确定后系统进行数据分析生成对比记录。可用于企业产品间的竞品分析、不同事件的影响力对比分析等。',proIntr:'<p>对比分析功能从信息总量、综合指数、热门主题词、情感属性、媒体分布、发布热区、文章类型7个维度进行分析。</p><div class="proDetail-img  mt20"><img src="'+this.$parent.baseUrl+'/static/images/product/img42.png"><img src="'+this.$parent.baseUrl+'/static/images/product/img43.png"></div><p class="mt20">用户可将分析结果形成H5分享至微信，在H5界面选择定制分享后输入对比对象形成专属H5。</p><div class="proDetail-img  mt20"><img src="'+this.$parent.baseUrl+'/static/images/product/img44.png"><img src="'+this.$parent.baseUrl+'/static/images/product/img45.png"></div>'},
				{id:15,name:'事件传播路径分析',urlList:this.$baseUrl+'/eventsPath',updateTime:'2020-07-23 21:00:00',intr:'事件在互联网传播过程中，信息发布转发关系图，便于用户清晰的了解事件的发酵传播过程。用户可以通过不同形式清晰查看分析话题的传播路径，包括话题传播的平台和各平台上的媒体情况。',proIntr:'<p>用户可通过自由编辑事件关键词，进行事件设置，设置完成后，自动汇总多方信息，针对事件进行多维度信息图表分析，传播路径清晰展示信息转发关系，为用户提供实时的事件发酵过程跟踪分析。功能展示图如下：</p><div class="proDetail-img mt20"><img src="'+this.$parent.baseUrl+'/static/images/product/eventsDetail.png"></div>'},
				{
					id:17,
					name:'统计数据查询',
					urlList:'http://model.nybkz.com/statisticsData/schemeQuery',
					updateTime:'2018-11-28 21:19:11',
					intr:'可通过设置关键字，以及设置的分析时间段搜集符合条件的数据，系统对采集入库的数据进行分析统计。',proIntr:'<p>1.多方案查询：用户可一次性设置多个方案关键词以及排除词（最多10个），系统将全网相关数据进行聚类统计，用户可在下载中心下载数据。</p><div class="proDetail-img mt20"><img src="'+this.$parent.baseUrl+'/static/images/product/img67.png"></div><p class="mt20">2.批量查询：用户可按照模板填写需要查询的事件，可一次性填写多个，查询时间可自定义，批量上传后可得到相关事件的全网数据。</p><div class="proDetail-img mt20"><img src="'+this.$parent.baseUrl+'/static/images/product/img68.png"></div><p class="mt20">3.下载中心：查询方案设置后，支付完成，用户可在下载中心下载查询数据。</p><div class="proDetail-img mt20"><img src="'+this.$parent.baseUrl+'/static/images/product/img69.png"></div>'
				},
				{
					id:18,name:'全文检索',
					urlList:this.$baseUrl+'/fullTextSearch',
					updateTime:'2018-11-28 15:41:43',
					intr:'用户可输入查询词在全库检索数据，不局限于方案内数据检索。',
					proIntr:'<p>无需设置方案，快捷输入任意感兴趣的话题，即可迅速获取相关话题信息，并对信息进行全网分布状态统计，高效率的整合搜索，简单的操作方式，为用户在最短的时间内提供完整、准确、及时的数据信息</p><div class="proDetail-img mt20"><img src="'+this.$baseUrl+'/static/images/product/img70.jpg"><img src="'+this.$baseUrl+'/static/images/product/img71.jpg"></div>'
				}
            ],
        }
    },
    mounted() {
		let that = this;
		that.$nextTick(()=> {
            that.dataAjax();
        })
    },
    methods: {
		dataAjax(){
            let that = this;
            that.proList.forEach((ele,index) => {
                if(that.sid == ele.id){
                    that.tit =  ele.name;
                    that.updateTime =  ele.updateTime;
                    that.intr =  ele.intr;
                    that.proIntr =  ele.proIntr;
                }
            });
        },
        openUrl(){
            let that = this;
            let routeData
            if(this.$route.query.id == 18){
                routeData = that.$router.resolve({
                    path: that.$baseUrl+'/fullTextSearch'
                });
            }else{
                routeData = that.$router.resolve({
                    path: that.$baseUrl+'/eventsPath'
                });
            }
            window.open(routeData.href, '_blank');
        },
        openState(){
            let that = this;
            let data = {
                productId:that.sid
            }
            that.$parent.loadModal(true,'正在开通...');
            that.$api.post('productMarket/index/open-product',{data:data}, r => {
                that.$parent.returnCode(r,function(){
                    that.proList.forEach((ele,index) => {
                        if(that.sid == ele.id){
                            that.$parent.loadModal(false);
                            if(ele.id === 18){

                                let routeData = that.$router.resolve({
                                    path: ele.urlList
                                });
                                window.open(routeData.href, '_blank');
                            }else{
                                window.open(ele.urlList,"_blank")
                            }
                        }
                    });
                })
            });

        }
	}
}
</script>
<style>
    .proDetail-img{background-color:#efeeec;text-align:center;margin-bottom:32px;padding:15px 0}
    .proDetail-img img{max-width:100%;vertical-align: middle;}
</style>




// WEBPACK FOOTER //
// src/page/productCenter/productDetail.vue